Vue.component('lead-quality-apps', require('./LeadQuality/vue/lead-quality-apps').default);

Vue.component('mc-app-debug', require('./Application/Tests/vue/mc-app-debug').default);